import {
  getDomainAttribute,
  getSecureAttribute,
} from "./cookieAttributes.helper";

export const clearCookie = (cookieName: string): void => {
  if (typeof document === "undefined" || !document.cookie) return;

  const secureAttribute = getSecureAttribute();
  const domainAttribute = getDomainAttribute();

  document.cookie = `${cookieName}=; Domain=${domainAttribute}; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict${secureAttribute}`;
};
